import React, { useEffect, useContext } from 'react'
import { log } from '../../services/LogService'
import { StateContext } from '../../services/StateService'
import PropTypes from 'prop-types'
import WtbConst from '../../../common/constants/WtbEnum'

const ServiceLocator = ({ widgetId, subId }) => {
    const { locale } = useContext(StateContext)

    const convertedLocale = locale.replace(/_/, '-')
    const language = locale.split('_')
    useEffect(() => {
        loadServiceLocator()
    }, [])

    const loadServiceLocator = () => {
        const serviceLocatorScript = document.createElement('script')
        serviceLocatorScript.id = 'service-locator-widget'
        serviceLocatorScript.type = 'text/javascript'
        serviceLocatorScript.src = WtbConst.CC_SERVICE_LOCATOR_URL
        serviceLocatorScript.setAttribute(
            'data-token',
            WtbConst.CC_TOKEN
        )
        serviceLocatorScript.setAttribute('data-locale', convertedLocale)
        serviceLocatorScript.setAttribute('data-displaylanguage', language[0])
        serviceLocatorScript.setAttribute('data-widgetid', widgetId)
        serviceLocatorScript.setAttribute('data-subid', subId)
        serviceLocatorScript.addEventListener('load', () => {
            log.debug('serviceLocatorScript loaded')
        })
        serviceLocatorScript.addEventListener('error', () => {
            log.warn('serviceLocatorScript failed')
        })

        document
            .querySelector('.sps2-pdp_serviceLocator--container')
            .appendChild(serviceLocatorScript)
    }

    return <div className={`sps2-pdp_serviceLocator--container`}></div>
}

ServiceLocator.propTypes = {
    widgetId: PropTypes.string,
    subId: PropTypes.string
}

export default ServiceLocator
